export const FootnoteEditorSchema = {
  title: 'Footnote entry',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['footnote'],
    },
  ],
  properties: {
    footnote: {
      title: 'Reference text',
      widget: 'searchInput',
      choices: [],
    },
  },
  required: [],
};
